
import { Vue, Component, Watch } from "vue-property-decorator"
import CuratorSearchForm from "@/components/Article/CuratorSearchForm.vue"
import { mapActions } from "vuex"
import { Curator } from "types/curator"
import { DataTableHeader } from "vuetify/types"

@Component({
  components: { CuratorSearchForm },
  methods: {
    ...mapActions("article", ["updateArticle"]),
  },
})
export default class SelectCurator extends Vue {
  get headers(): DataTableHeader[] {
    return [
      { text: "ID", value: "id" },
      { text: "名前", value: "name" },
      { text: "選択", value: "select", sortable: false },
    ]
  }

  public dialog = false

  private curators: Curator["view"][] = []
  private loading = false
  private totalPages = 0
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }

  public clear(): void {
    this.curators.length = 0
    this.curators = []
    this.resetPagination()
    const form = this.$refs.curatorSearchForm as InstanceType<
      typeof CuratorSearchForm
    >
    form.reset()
  }

  public searchResult(result: Curator["view"][], totalPages: number): void {
    this.curators = result
    this.totalPages = totalPages
    this.loading = false
  }

  private close() {
    this.dialog = false
    this.clear()
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    if (this.dialog) {
      this.loading = true
      setTimeout(() => {
        const curatorSearchForm = this.$refs.curatorSearchForm as InstanceType<
          typeof CuratorSearchForm
        >
        const page = this.pagination.page
        const sortBy = this.pagination.sortBy[0]
        const descending = this.pagination.sortDesc[0]
        curatorSearchForm.search(page, sortBy, descending)
        this.loading = false
      }, 500)
    }
  }

  private select(curator: Curator["view"]) {
    this.$store.dispatch("article/updateArticle", { curator })
    this.close()
  }
}
